import { render, staticRenderFns } from "./SubjectTitle.vue?vue&type=template&id=46f1bcff&scoped=true&"
import script from "./SubjectTitle.vue?vue&type=script&lang=ts&"
export * from "./SubjectTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectTitle.vue?vue&type=style&index=0&id=46f1bcff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f1bcff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
